import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appMuTableCaption]',
})
export class MuTableCaptionDirective {
  @Input('appMuTableCaption') name: string;

  constructor(public template: TemplateRef<any>) {
    /** */
  }
}
